// dashboard-revamp: client-side "recently accessed stations" for /dashboard.
//
// localStorage, NOT a server table — deliberately. The dashboard works logged
// out and recents should too; a per-account server list would gate the feature
// behind auth and add a privacy surface for what is really just this browser's
// own history. The trade: recents don't follow the user across devices, and a
// station renamed/decommissioned since the visit renders from its stored copy
// (the link then resolves — or 404s — like any bookmark would).

const KEY = 'aveq.recentStations';
const MAX = 12;
// station-url-hash: only /s/<url_token> is a station address; older id-based paths 404.
const STATION_PATH = /^\/s\/(?!\d+$)[A-Za-z0-9_-]+$/;

export function getRecentStations() {
  try {
    const raw = JSON.parse(window.localStorage.getItem(KEY) || '[]');
    if (!Array.isArray(raw)) return [];
    // Entries are only ever rendered as a link + text; drop anything that
    // can't do both so one corrupt row doesn't take the section down.
    return raw.filter((e) => e && e.path && e.name && STATION_PATH.test(e.path));
  } catch (_) {
    return [];
  }
}

// A station picture is usually a small data-URI; a large one isn't worth the storage.
const MAX_IMAGE_CHARS = 16000;

export function recordStationVisit({ stationId, name, path, image }) {
  if (!stationId || !name || !path || !STATION_PATH.test(path)) return;
  try {
    const entry = { station_id: stationId, name, path, ts: Date.now() };
    if (typeof image === 'string' && image && image.length <= MAX_IMAGE_CHARS) entry.image = image;
    const rest = getRecentStations().filter((e) => e.station_id !== stationId);
    window.localStorage.setItem(KEY, JSON.stringify([entry, ...rest].slice(0, MAX)));
  } catch (_) {
    // Storage full / private mode — recents are a convenience, never an error.
  }
}
